module.exports = __webpack_public_path__ + "img/andrea.e3b55c2b.png";